import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { BloodProductAdministrationConstants } from '../store/bloodProductAdministration.constants'
import { IBloodProductAdministrationState } from '../store/bloodProductAdministration.types'
import { getBloodProductAdministrationSelector } from '../selectors/bloodProductAdministration.selector'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setPtVerified() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const bloodProductAdministrationState: IBloodProductAdministrationState = yield select(
    getBloodProductAdministrationSelector
  )
  const { inputRows } = procedureState
  try {
    const { ptIdVerified, witness1, witness2 } = bloodProductAdministrationState
    inputRows.map((row) =>
      row.inputs.map((input) => {
        if (input.key === BloodProductAdministrationConstants.SET_PT_ID_VERIFIED) {
          //@ts-ignore
          input.props.savedValues = ptIdVerified
        }
        if (input.key === BloodProductAdministrationConstants.SET_WITNESS1) {
          input.hidden = !ptIdVerified || ptIdVerified?.id !== 1
          //@ts-ignore
          input.props.inputValue = witness1
        }
        if (input.key === BloodProductAdministrationConstants.SET_WITNESS2) {
          input.hidden = !ptIdVerified || ptIdVerified?.id !== 1
          //@ts-ignore
          input.props.inputValue = witness2
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setPtVerified() error: ${e}`))
  }
}

export function* setPtVerifiedSaga() {
  yield takeLatest([BloodProductAdministrationConstants.SET_PT_ID_VERIFIED], performWithMutexHOG, setPtVerified)
}
